import { faCircle as lightCircle } from "@jewlr/pro-light-svg-icons/faCircle"
import { faCheckCircle as solidCheckCircle } from "@jewlr/pro-solid-svg-icons/faCheckCircle"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import { fetchInventory, updateChoice } from "areas/product/store/actions"
import Modal, { closeModal } from "components/modal"
import Button from "components/ui/button"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Image from "components/ui/image"
import { imageLookup } from "helpers/product/image-lookup"
import { filterProductOptions } from "helpers/product/product-filtering"
import { cn } from "styles/utils"

const InternalInventoryTableModal = ({
  getAllInventory,
  handleChange,
  inventory,
  selectedMetalFilter,
  selectedSize,
  selectedStoneCount,
  setChoice,
  sizes,
  skus,
  stoneCounts,
}) => {
  return (
    <Modal label={`${sl.config.guaranteed_holiday} Delivery`} show="#inventory">
      {inventory && (
        <>
          <div className="px-14 text-center">
            <Image
              alt="Free shipping"
              className="mb-15"
              src={require("images/layout/footer/perks/freeshipping.svg")}
              style={{ width: "40px" }}
            />
            <p className="text-14 text-black">
              This item in select metals{!!sizes && " and sizes"}
              <br />
              is available for {sl.config.guaranteed_holiday} Delivery.
            </p>

            <p className="mb-8">
              Select a configuration below to update your item. Configurations
              marked in green are available for{" "}
              <span className="nowrap">
                {sl.config.guaranteed_holiday} Delivery.
              </span>
            </p>
            {!!sizes && (
              <div className="mb-10">
                Choose your size:{" "}
                <select
                  onChange={(e) => handleChange(e, "sz")}
                  value={selectedSize}
                >
                  {filterProductOptions(
                    sizes.options,
                    selectedMetalFilter,
                    true
                  ).map((sz, index) => (
                    <option key={index} value={sz.value}>
                      {sz.value}
                    </option>
                  ))}
                </select>
              </div>
            )}
            {inventory.showStoneCount && !!stoneCounts && (
              <div className="my-10">
                <label className="mb-5 block">
                  How many stones would you like?
                </label>
                <select
                  onChange={(e) => handleChange(e, "sc")}
                  value={selectedStoneCount}
                >
                  {stoneCounts.options.map((sc, index) => (
                    <option key={index} value={sc.value}>
                      {sc.value}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>

          <div className="bg-grey-4 tablet:py-10 tablet:px-40 my-20 w-full overflow-x-auto px-10">
            <table className="w-full">
              <thead>
                <tr className="border-b-grey-10 border-b">
                  {inventory.attributes.map((attribute, index) => (
                    <th
                      className="p-10 text-center text-black first:pl-0 first:text-left"
                      key={index}
                    >
                      {attributeName(attribute)}
                    </th>
                  ))}
                  {skus.map((sku, index) => (
                    <th
                      className="p-10 text-center text-black first:pl-0 first:text-left"
                      key={index}
                    >
                      <Image
                        alt={sku.title}
                        className="w-(--base-width) tablet:w-(--tablet-width)"
                        height="40"
                        src={imageLookup("sku", sku.value).x1}
                        style={{
                          "--base-width": "25px",
                          "--tablet-width": "35px",
                        }}
                        title={sku.title}
                        width="40"
                      />
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {inventory.available_inventories.map((inv, index) => {
                  const attributes = inv.item_attributes_hash
                  return (
                    <tr
                      className={`border-b ${index < inventory.available_inventories.length - 1 && "border-b-grey-10"}`}
                      key={index}
                    >
                      {inventory.attributes.map((attribute, index) => (
                        <td
                          className="p-10 text-center font-light text-black first:pl-0 first:text-left"
                          dangerouslySetInnerHTML={{
                            __html: attributeName(attributes[attribute]),
                          }}
                          key={index}
                        />
                      ))}
                      {Object.keys(inv.sku_availability_hash).map(
                        (sku, index) => {
                          const available =
                            inv.sku_availability_hash[sku].available_holiday
                          return (
                            <td
                              className="p-10 text-center font-light text-black first:pl-0 first:text-left"
                              key={"s" + index}
                            >
                              <Button
                                aria-label={
                                  available ? "Available" : "Not Available"
                                }
                                onClick={() => {
                                  setChoice(sku, attributes)
                                  closeModal()
                                }}
                              >
                                <FontAwesomeIcon
                                  className={cn(
                                    "text-20",
                                    available
                                      ? "text-green-darker"
                                      : "text-grey-20"
                                  )}
                                  icon={
                                    available ? solidCheckCircle : lightCircle
                                  }
                                />
                              </Button>
                            </td>
                          )
                        }
                      )}
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
          {!!sizes && (
            <div className="text-center">
              <Button
                className="mb-16"
                onClick={() => getAllInventory()}
                variant="secondary"
              >
                Show All Sizes
              </Button>
            </div>
          )}
        </>
      )}
    </Modal>
  )
}

const attributeName = (attribute) => {
  switch (attribute) {
    case "sz":
      return "Size"
    case "as":
      return "Accents"
    case "sc":
      return "Stone Count"
    case "CZ":
      return "Cubic<br />Zirconia"
    case "DIA":
      return "Genuine<br />Diamond"
    default:
      return attribute
  }
}
const getSelectedMetalFilter = (state) => {
  if (typeof state.choices.sku === "undefined") {
    return ""
  } else {
    // return state.choices.sku.filter || ''
    return {
      pref: "sku",
      value: state.choices.sku.value,
    }
  }
}

const mapStateToProps = (state) => {
  return {
    inventory: state.wizard.inventory,
    selectedMetalFilter: getSelectedMetalFilter(state),
    selectedSize: state.choices.sz ? state.choices.sz.value || "" : "",
    selectedStoneCount: state.choices.sc ? state.choices.sc.value || "" : "",
    sizes: state.wizard.data && state.wizard.data.sz,
    skus:
      state.wizard.data && state.wizard.data.sku
        ? state.wizard.data.sku.options
        : [],
    stoneCounts: state.wizard.data.sc,
    wizardData: state.wizard.data,
  }
}

const mapDispatchToProps = (dispatch) => {
  return { dispatch }
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { wizardData } = stateProps
  const { dispatch } = dispatchProps
  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    getAllInventory: () => {
      dispatch(fetchInventory({ get_all_sizes: true }))
    },
    handleChange: (e, pref) => {
      // Find the object to send directly to updateChoice
      const val = e.target.value
      if (val == "") {
        dispatch(updateChoice(pref, { value: "" }))
      } else {
        let selectedValue = wizardData[pref].options.find(
          (option) => option.value == val
        )
        try {
          dispatch(updateChoice(pref, selectedValue))
        } catch (err) {
          console.log(err)
        }
      }
      dispatch(fetchInventory())
    },
    setChoice: (sku, attributes) => {
      // Update metal choice
      let selectedMetal = wizardData.sku.options.find(
        (metal) => metal.value == sku
      )
      dispatch(updateChoice("sku", selectedMetal))

      // Update each attribute choice
      for (let attribute in attributes) {
        let attributeValue = attributes[attribute]
        if (attribute === "as") {
          attributeValue = attributeValue == "CZ" ? "04CZIR" : "04DIAM"
        }
        let selectedValue = wizardData[attribute].options.find(
          (option) => option.value == attributeValue
        )
        dispatch(updateChoice(attribute, selectedValue))
      }
    },
  }
}

InternalInventoryTableModal.propTypes = {
  getAllInventory: PropTypes.func,
  handleChange: PropTypes.func,
  inventory: PropTypes.object,
  routerHash: PropTypes.string,
  selectedMetalFilter: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  selectedSize: PropTypes.string,
  selectedStoneCount: PropTypes.string,
  setChoice: PropTypes.func,
  sizes: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  skus: PropTypes.array,
  stoneCounts: PropTypes.object,
}

const InventoryTableModal = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(InternalInventoryTableModal)

export default InventoryTableModal
